






























import { Component, Watch } from "vue-property-decorator";
import { BaseOperationPropertyVue } from "fs-pb-vue2/vueModels/operations/properies/BaseOperationPropertyVue";

@Component({})
export default class AdressProperty extends BaseOperationPropertyVue {

  @Watch('propery.Value', { immediate: true })
  async valueChanged(val: string) {
    if (val && val.length > 0) {
      this.adressLoading = true;
      const options: any = {
          method: "POST",
          mode: "cors",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/json",
              "Authorization": "Token " + "8f7c031d595763abb0413427b79c229182a50925"
          },
          body: JSON.stringify({query: val})
      }

      const response: any = await fetch('https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address', options);
      const respJson: any = await response.json();
      if (respJson && respJson.suggestions)
        this.suggestions = respJson.suggestions;
      this.adressLoading = false;
    }
  }

  onAdressBlur(): void {
    if (!this.suggestions.length) {
      this.listActive = false;
      this.onBlur();
      return;
    }
    if (!this.suggestions.find((sug: any) => sug.value === this.property.Value)) {
      this.property.setProperty(this.suggestions[0].value);
    }
    setTimeout(() => {
      this.listActive = false;
      this.onBlur();
    }, 100);
  }

  onAdressFocus(): void {
    this.listActive = true;
    this.onFocus();
  }

  selectSuggest(suggest: any) {
    if (suggest) {
      this.property.setProperty(suggest.value);
    }
  }

  suggestions: Array<any> = [];

  listActive: boolean = false;

  adressLoading: boolean = false;

}
